import React from 'react';
import { Proposal } from './pages/Proposal';
export function App() {
  return <Proposal data-id="element-0" />;
}